/** Extensões/MIME aceitos pelo backend (alinhado a validation.py). */
export function supportedFile(file) {
  const name = file.name.toLowerCase();
  const okExt =
    name.endsWith('.jpeg')
    || name.endsWith('.jpg')
    || name.endsWith('.png')
    || name.endsWith('.pdf')
    || name.endsWith('.bmp')
    || name.endsWith('.tiff')
    || name.endsWith('.tif');
  const mt = (file.type || '').toLowerCase();
  const okMime =
    mt.startsWith('image/jpeg')
    || mt === 'image/png'
    || mt === 'image/bmp'
    || mt === 'image/tiff'
    || mt === 'application/pdf';
  return okExt || okMime;
}

export const IDP_UPLOAD_ACCEPT = '.jpeg,.jpg,.png,.pdf,.bmp,.tiff,.tif,image/*,application/pdf';
